<template>
    <div>
        <div v-src="'https://oss.cloud.custouch.com/res/27567/维生素学院-Banner.jpg'"
             class="default-banner-wrapper">
            <span>维生素学苑<em>-维妙维效</em></span>
            <span class="tip">缤纷科技，美好生活<sup>TM</sup></span>
        </div>
        <TabCard :options="tabOptions" />
    </div>
</template>
<script>
import TabCard from './compoennts/TabCard'
export default {
    components: {
        TabCard
    },
    data() {
        return {
            tabOptions: [
                {
                    name: 'SchoolIntro',
                    text: '学苑介绍'
                },
                {
                    name: 'OfflineActivity',
                    text: '活动简介'
                }
            ]
        }
    },

}
</script>